import { makeStyles, shorthands } from "@fluentui/react-components";
import { FONT_ACCENT, FONT_BODY } from "../theme";

export const useStepStyles = makeStyles({
  stepHead: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "20px",
  },
  stepEyebrow: {
    color: "var(--sm-accent)",
    fontFamily: FONT_BODY,
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    margin: 0,
  },
  stepTitle: {
    margin: 0,
    color: "var(--sm-primary-deep)",
    fontFamily: FONT_ACCENT,
    fontSize: "clamp(1.5rem, 3.6vw, 2.1rem)",
    fontWeight: 500,
    lineHeight: 1.15,
  },
  stepHint: {
    margin: 0,
    color: "#6c6171",
    fontFamily: FONT_BODY,
    fontSize: "0.95rem",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "14px",
    "@media (min-width: 640px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "14px",
    "@media (min-width: 640px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
    "@media (min-width: 720px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    color: "var(--sm-primary-deep)",
    fontFamily: FONT_BODY,
    fontSize: "0.88rem",
    fontWeight: 600,
  },
  input: {
    appearance: "none",
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "var(--sm-input-bg)",
    color: "var(--sm-ink)",
    fontFamily: FONT_BODY,
    fontSize: "0.98rem",
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "14px",
    paddingRight: "14px",
    ...shorthands.border("1.5px", "solid", "var(--sm-card-border)"),
    ...shorthands.borderRadius("10px"),
    transitionProperty: "border-color, box-shadow",
    transitionDuration: "150ms",
    ":focus": {
      outline: "none",
      ...shorthands.borderColor("var(--sm-primary)"),
      boxShadow: "0 0 0 3px var(--sm-accent-soft)",
    },
  },
  textarea: {
    minHeight: "120px",
    resize: "vertical",
    fontFamily: FONT_BODY,
    fontSize: "0.98rem",
  },
  chipsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  chip: {
    appearance: "none",
    cursor: "pointer",
    backgroundColor: "#fff",
    color: "var(--sm-primary-deep)",
    fontFamily: FONT_BODY,
    fontSize: "0.85rem",
    fontWeight: 600,
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "14px",
    paddingRight: "14px",
    ...shorthands.border("1.5px", "solid", "var(--sm-card-border)"),
    ...shorthands.borderRadius("999px"),
    transitionProperty: "background-color, border-color, color",
    transitionDuration: "150ms",
    ":hover": {
      ...shorthands.borderColor("var(--sm-primary)"),
    },
  },
  chipActive: {
    backgroundColor: "var(--sm-accent)",
    color: "var(--sm-primary-deep)",
    ...shorthands.borderColor("var(--sm-accent)"),
  },
  consentRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    backgroundColor: "rgba(247,168,35,0.08)",
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "14px",
    paddingRight: "14px",
    ...shorthands.border("1px", "solid", "var(--sm-accent-soft)"),
    ...shorthands.borderRadius("10px"),
    fontFamily: FONT_BODY,
    fontSize: "0.88rem",
    color: "var(--sm-primary-deep)",
  },
  consentCheckbox: {
    marginTop: "3px",
    width: "20px",
    height: "20px",
    accentColor: "var(--sm-primary)",
    cursor: "pointer",
  },
});
